<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>二维码管理</el-breadcrumb-item>
      <el-breadcrumb-item>隐患点管理</el-breadcrumb-item>
    </el-breadcrumb>
   
  <!-- 卡片视图 -->
        <el-card class="box-card">
            <!-- 搜索与添加 -->
            <el-row :gutter="20">
                <el-col :span="8">
                </el-col>
                 <el-col :span="4">
                    <el-button type="primary" @click="addDialogVisible = true">添加隐患点</el-button>
                </el-col>
            </el-row>

            <!-- 考题列表 -->
            <el-table border stripe :data="userlist" style="width: 100%">
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column prop="classification" label="隐患点名称"></el-table-column>
                <el-table-column prop="ask" label="问题"></el-table-column>
                <el-table-column prop="A" label="A"></el-table-column>
                <el-table-column prop="B" label="B"></el-table-column>
                <el-table-column prop="C" label="C"></el-table-column>
                <el-table-column prop="D" label="D"></el-table-column>
                <el-table-column prop="answer" label="正确答案">
                    <template slot-scope="scope">
                        <div v-if="scope.row.answer == 1">A</div>
                        <div v-else-if="scope.row.answer == 2">B</div>
                        <div v-else-if="scope.row.answer == 3">C</div>
                        <div v-else>D</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                        <!-- 修改按钮 -->
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
                        <!-- 删除 -->
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.id)"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="block">
                <!-- <span class="demonstration">完整功能</span> -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum"
                :page-sizes="[2, 5, 10, 15]"
                :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>

        </el-card>

         <!-- 添加考题对话框 -->
        <el-dialog title="添加隐患点" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
            <!-- 内容主体区域 -->
            <el-form :model="addForm" ref="addFormRef" label-width="70px">
               <el-form-item label="隐患名称">
                   <el-input v-model="addForm.classification"></el-input>
                </el-form-item>
                <el-form-item label="题目">
                    <el-input v-model="addForm.ask"></el-input>
                </el-form-item>
                <el-form-item label="A">
                    <el-input v-model="addForm.A"></el-input>
                </el-form-item>
                <el-form-item label="B">
                    <el-input v-model="addForm.B"></el-input>
                </el-form-item>
                <el-form-item label="C">
                    <el-input v-model="addForm.C"></el-input>
                </el-form-item>
                 <el-form-item label="D">
                    <el-input v-model="addForm.D"></el-input>
                </el-form-item>
                <el-form-item label="答案">
                    <template>
                        <el-radio v-model="addForm.answer" :label="1">A</el-radio>
                        <el-radio v-model="addForm.answer" :label="2">B</el-radio>
                        <el-radio v-model="addForm.answer" :label="3">C</el-radio>
                        <el-radio v-model="addForm.answer" :label="4">D</el-radio>
                    </template>
                </el-form-item>
            </el-form>
            <!-- 底部区域 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addUser">确 定</el-button>
            </div>
        </el-dialog>

         <!-- 修改考题对话框 -->
        <el-dialog title="修改考题" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
            <!-- 内容主体区域 -->
            <el-form :model="editForm"  ref="editFormRef" label-width="70px">
                <el-form-item label="题目">
                    <el-input v-model="editForm.ask"></el-input>
                </el-form-item>
                <el-form-item label="A">
                    <el-input v-model="editForm.A"></el-input>
                </el-form-item>
                <el-form-item label="B">
                    <el-input v-model="editForm.B"></el-input>
                </el-form-item>
                <el-form-item label="C">
                    <el-input v-model="editForm.C"></el-input>
                </el-form-item>
                 <el-form-item label="D">
                    <el-input v-model="editForm.D"></el-input>
                </el-form-item>
                <el-form-item label="答案">
                    <template>
                        <el-radio v-model="editForm.answer" :label="'1'">A</el-radio>
                        <el-radio v-model="editForm.answer" :label="'2'">B</el-radio>
                        <el-radio v-model="editForm.answer" :label="'3'">C</el-radio>
                        <el-radio v-model="editForm.answer" :label="'4'">D</el-radio>
                    </template>
                </el-form-item>
            </el-form>
            <!-- 底部区域 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editUser">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
  data () {
    return {
      //   控制考题对话框的显示隐藏
      editDialogVisible: false,
      //   控制考题对话框的显示隐藏
      addDialogVisible: false,
      // 获取考题列表的参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少数据
        pagesize: 5
      },
      editForm: {
        classification:'',
        ask: '',
        A: '',
        B: '',
        C: '',
        D: '',
        answer: 0
      },
      // 添加考题的表单数据
      addForm: {
        classification: '',
        ask: '',
        A: '',
        B: '',
        C: '',
        D: '',
        answer: 0
      },
      userlist: [],
      total: 0,
    }
  },
  created () {
    this.getUserList()
  },
  methods: {
    async getUserList () {
      const { data: res } = await this.$http.post('/pagingRQsubject', { params: this.queryInfo })
      console.log(res);
     
      this.userlist = res.users
      this.total = res.totalpage
    },

    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
    //   console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 监听 页码值改变的事件
    handleCurrentChange (newpage) {
    //   console.log(newpage)
      this.queryInfo.pagenum = newpage
      this.getUserList()
    },
    // 监听添加考题对话框的关闭事件
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },

    // 添加按钮，添加新考题
    addUser () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        await this.$http.post('/PSrqSubject', this.addForm)
        this.$message.success('考题添加成功!')
        // 隐藏对话框
        this.addDialogVisible = false
        // 刷新
        this.getUserList()
      })
    },

    // 修改按钮
    editUser () {
      this.$refs.editFormRef.validate(async valid => {
        console.log(this.editForm);
        if (!valid) return
        await this.$http.post('/modifyRQsubject/' + this.editForm.id, {
          ask: this.editForm.ask,
          A: this.editForm.A,
          B: this.editForm.B,
          C: this.editForm.C,
          D: this.editForm.D,
          answer: this.editForm.answer
        })
        this.$message.success('考题修改成功!')
        // 隐藏对话框
        this.editDialogVisible = false
        // 刷新
        this.getUserList()
      })
    },
    // 修改表单的验证规则对象
    async showEditDialog (id) {
      const { data } = await this.$http.get('/RQidSubjectID/' + id)

      this.editForm = data[0]

      this.editDialogVisible = true
      console.log(data)
    },
    // 监听修改考题对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },

    // 删除按钮
    async removeUserById (id) {
      const confirmResult = await this.$confirm('此操作将永久删除该考题，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除!')
      }
      console.log(111)
      const { data } = await this.$http.delete('/RQsubject/remove/' + id)
      this.$message.success('考题删除成功!')
      // // 刷新
      console.log(123);
      
        this.getUserList()
      console.log(data);
    }
  }
}
</script>

<style lang="less" scoped>
</style>
